export default __webpack_public_path__ + "static/qchange-case-study-9dc069f1ae7b0f22a8b7f2dc4ba66a7a.webp";